import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'projects/back-office/src/environments/environment';
import { Observable } from 'rxjs';
import { Operator, OperatorPostData, OperatorTemp } from './operator';

@Injectable({ providedIn: 'root' })
export class OperatorsService {
  private http = inject(HttpClient);

  private baseUrl = '/operators'; // Replace with your actual base URL
  private operatorsUrl = `${environment.backendServer}${this.baseUrl}`;
  private dashboardUrl = `${environment.backendServer}/dashboard${this.baseUrl}`;

  getOperators(options?: HttpParams): Observable<Operator[]> {
    return this.http.get<Operator[]>(this.operatorsUrl, { params: options });
  }

  createOperator(data: OperatorPostData): Observable<Operator> {
    return this.http.post<Operator>(this.operatorsUrl, data);
  }

  getOperatorById(id: string): Observable<Operator> {
    return this.http.get<Operator>(`${this.operatorsUrl}/${id}`);
  }

  updateOperator(id: string, data: OperatorPostData): Observable<Operator> {
    return this.http.put<Operator>(`${this.operatorsUrl}/${id}`, data);
  }

  deleteOperator(id: string): Observable<any> {
    return this.http.delete<any>(`${this.operatorsUrl}/${id}`);
  }

  getDashboardOperators(options?: HttpParams): Observable<OperatorTemp[]> {
    return this.http.get<OperatorTemp[]>(this.dashboardUrl, {
      params: options,
    });
  }

  approveOperator(id: string, data: any): Observable<Operator> {
    return this.http.put<Operator>(`${this.operatorsUrl}/${id}/approve`, data);
  }
}
